import config from '../../config.json';
import { SupportedFilesTypes } from './formats';

export interface IRequestParams {
    systemId: string;
    documentId: string; 
    versionUid: string;
    userId: string;
}

export const _RequestParams = (systemId: string, documentId: string, versionUid: string, userId: string) : IRequestParams => {
    return {
        systemId: systemId,
        documentId: documentId,
        versionUid: versionUid,
        userId: userId
    } as IRequestParams;
}

export const EmptyRequestParams = () : IRequestParams => {
    return {
        systemId: null!,
        documentId: null!,
        versionUid: null!,
        userId: null!
    } as IRequestParams;
}

interface IUser {
    name: string;
    email: string;
}

export const EmptyUser = () : IUser => {
    return {
        name: null!,
        email: null!
    } as IUser
}

interface IDocumentMetadataFile {
    name: string;
    ext: string;
    size: number;
    bodyUid: string;
}

export const EmptyDocumentMetadataFile = () : IDocumentMetadataFile => {
    return {
        name: null!,
        ext: null!,
        size: null!,
        bodyUid: null!
    } as IDocumentMetadataFile
}

interface IDocumentMetadata {
    isNowCollaborated: boolean;
    name: string;
    supportedTypes: string[];
    supportedApp: string;
    documentType: string;
    isSupported: boolean;
    versionNumber: string;
    creationDate: Date;
    isBlocked: Boolean;
    blockedDate: Date;
    file: IDocumentMetadataFile;
}

export const EmptyDocumentMetadata = () : IDocumentMetadata => {
    return {
        isNowCollaborated: false,
        name: null!,
        supportedTypes: SupportedFilesTypes,
        supportedApp: null!,
        documentType: null!,
        isSupported: null!,
        versionNumber: null!,
        creationDate: null!,
        isBlocked: null!,
        blockedDate: null!,
        file: EmptyDocumentMetadataFile()
    } as IDocumentMetadata
}

interface IDocumentAccess {
    allowRead: boolean;
    allowEdit: boolean;
    allowDownload: boolean;
    allowExport: boolean;
}

export const DefaultDocumentAccess = () : IDocumentAccess => {
    return { allowRead: false, allowEdit: false, allowDownload: false, allowExport: false } as IDocumentAccess;
}

interface IDocument {
    name: string;
    metadata: IDocumentMetadata;
    access: IDocumentAccess;
    body: any;
}

export const EmptyDocument = () : IDocument => {
    return { name: null!, metadata: EmptyDocumentMetadata(), access: DefaultDocumentAccess(), body: null! } as IDocument;
}

export interface IDocumentWoutBody {
    name: string;
    metadata: IDocumentMetadata;
    access: IDocumentAccess;
    requestParams: IRequestParams,
    user: IUser;
}

export interface IDocumentRevisions {
    enabled: boolean;
    comments: any;
    revisions: any;
}

export interface IDocumentLoader {
    success: boolean;
    invalidUrl: boolean;
    error: { message: string, details: string },
    requestParams: IRequestParams,
    user: IUser;
    document: IDocument;
    isExternal?: boolean;
}

export const CreateDocumentLoader = (result: IResult) : IDocumentLoader => {
    return {
        success: result.success,
        invalidUrl: false,
        error: result.error,
        requestParams: EmptyRequestParams(),
        user: EmptyUser(),
        document: EmptyDocument()
    } as IDocumentLoader
}

export interface IErrorObject {
    message: string;
    details?: string;
}

export interface IError {
    error: IErrorObject;
}

interface IData {
    data: any;
}

export interface IResult extends IError, IData {
    success: Boolean;
};

export const Success = (data: Object) => {
    let result = {} as IResult;
    let errorObject = { message: '', details: '' } as IErrorObject;
    result.success = true;
    result.error = errorObject;
    result.data = data;
    //Loggers.defaultLogger.info(errorObject.message,errorObject.details);
    return result;
}

export const Errors = (message: string, details?: any, data?: Object) => {
    let result = {} as IResult;
    let errorObject = {} as IErrorObject;
    result.success = false;
    errorObject.message = message;
    errorObject.details = details ? details.toString() : null;
    result.error = errorObject;
    result.data = data ? data : {
        type: 'global',
        message: message
    };
    return result;
}

export function saveDocument2Contentum(document: IDocumentWoutBody, documentRevisions: IDocumentRevisions, fileBody: Blob) : Promise<any> {

    function getCircularReplacer() {
        const seen = new WeakSet();
        return (key : any, value : any) => {
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) {
                    return;
                }
                seen.add(value);
            }
            return value;
        };
    }

    const body = new FormData();
    body.set("document", JSON.stringify(document));
    console.log(documentRevisions);
    body.set("revisions", JSON.stringify(documentRevisions, getCircularReplacer()));
    //body.set("revisions", JSON.stringify({}));
    body.set("file", fileBody);

    return new Promise(function(resolve) {

        fetch(config.settings.baseServerUrl + '/client/api/save', {
            method: 'POST',
            body: body
        })
        .then(async (resp: any) => {
            return resp;
        })
        .then(async (resp: any) => {
            if (resp.status != 200 && resp.status != 304) {
                return resolve(Errors('Error update document version body','Error upload document to contentum server: status=' + resp.status + ', text=' + resp.statusText ));
            } else {
                const jsonObj : IResult = await resp.json();
                if (jsonObj.success) {
                    return resolve(jsonObj);
                } else {
                    return resolve(Errors(jsonObj.error.message,jsonObj.error.details,jsonObj.data));
                }  
            }
        })
        .catch((error: Error) => {
            return resolve(Errors('Server connection error','Error connected to server: ' + error.message,error));
        })

    });
}

export function saveDocument2Service(document: IDocumentWoutBody, fileBody: Blob) : Promise<any> {

    const body = new FormData();
    body.set("document", JSON.stringify(document));
    body.set("file", fileBody);

    return new Promise(function(resolve) {

        fetch(config.settings.baseServerUrl + '/client/api/external/document/save', {
            method: 'POST',
            body: body
        })
        .then(async (resp: any) => {
            return resp;
        })
        .then(async (resp: any) => {
            if (resp.status != 200 && resp.status != 304) {
                return resolve(Errors('Error update document version body','Error upload document to contentum server: status=' + resp.status + ', text=' + resp.statusText ));
            } else {
                const jsonObj : IResult = await resp.json();
                if (jsonObj.success) {
                    return resolve(jsonObj);
                } else {
                    return resolve(Errors(jsonObj.error.message,jsonObj.error.details,jsonObj.data));
                }  
            }
        })
        .catch((error: Error) => {
            return resolve(Errors('Server connection error','Error connected to server: ' + error.message,error));
        })

    });
}